var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-wi-step",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"btn-center-content"},[_c('b-icon',{attrs:{"icon":"subdirectory-arrow-right","size":"fa-2x"}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }